import { replaceString } from './replace.js';

function trimAll(input) {
  return input.replace(/\s+/g,' ').replace(/^\s+|\s+$/,'');
};

export { replaceString, trimAll }